import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import ThronIntegrationComponent from './../../scripts/components/thronIntegrationComponent';
const ThronVideo = (props) => {
    const videoRef = useRef();
    const [thronComponent, setThronComponent] = useState(null);
    useEffect(() => {
        if (videoRef.current) {
            if (thronComponent) {
                thronComponent.changeContent(props.thronID);
            }
            else {
                const options = {};
                props.onPauseCallback && (options.onPauseCallback = props.onPauseCallback);
                props.onPlayCallback && (options.onPlayCallback = props.onPlayCallback);
                props.onCompleteCallback && (options.onCompleteCallback = props.onCompleteCallback);
                props.onInitCallback && (options.onInitCallback = props.onInitCallback);
                props.onTimeUpdate && (options.onTimeUpdate = props.onTimeUpdate);
                typeof props.loopTimes === 'number' && (options.loopTimes = props.loopTimes);
                const newThronComponent = new ThronIntegrationComponent(videoRef.current, 'video', options);
                setThronComponent(newThronComponent);
            }
        }
    }, [props.thronID]);
    return (React.createElement("div", { ref: videoRef, "aria-hidden": "true", className: classNames('video-wrapper', props.className), "data-option-id": props.thronID, "data-option-mobile-id": props === null || props === void 0 ? void 0 : props.thronMobileID, "data-option-muted": props.muted, "data-option-autoplay": props.autoplay, "data-option-loop": props.loop, "data-option-lock-bitrate": props.lockBitrate, "data-option-no-skin": props.noskin, "data-option-sess-id": props.sessionId }));
};
export default ThronVideo;
